export default "__VITE_ASSET__DtBMod_w__"